import React, { useEffect } from 'react'
import { default as Pages } from 'react-bootstrap-4-pagination'

const Pagination = ({ currentPage, currentSize, totalRecords, handleChange }) => {

  let paginationConfig = {
    totalPages: Math.ceil(totalRecords/currentSize),
    currentPage: currentPage,
    showMax: 5,
    size: "md",
    center: false,
    prevNext: true,
    onClick: (page) => handleChange(page)
  };

  return (
    <Pages {...paginationConfig} />
  )
}

export default Pagination